<template>
    <div class="index">
        <Header></Header>
        <div style="clear:both;"></div>
        <div class="banner_box2">
            <div class="swiper-wrapper">
                <el-carousel :interval="5000" arrow="always" height="700px">
                    <el-carousel-item>
                        <h3 class="medium">
                            <img class="img" src="../assets/images/banner.jpg" alt=""
                                style="height: 700px;width:100%;background-size: 100% 100%;">
                        </h3>
                    </el-carousel-item>
                    <el-carousel-item>
                        <h3 class="medium">
                            <img class="img" src="../assets/images/banner2.jpg" alt=""
                                style="height: 700px;width:100%;background-size: 100% 100%;">
                        </h3>
                    </el-carousel-item>
                    <el-carousel-item>
                        <h3 class="medium">
                            <img class="img" src="../assets/images/banner3.jpg" alt=""
                                style="height: 700px;width:100%;background-size: 100% 100%;">
                        </h3>
                    </el-carousel-item>
                    <el-carousel-item>
                        <h3 class="medium">
                            <img class="img" src="../assets/images/banner4.jpg" alt=""
                                style="height: 700px;width:100%;background-size: 100% 100%;">
                        </h3>
                    </el-carousel-item>
                    <el-carousel-item>
                        <h3 class="medium">
                            <img class="img" src="../assets/images/banner5.jpg" alt=""
                                style="height: 700px;width:100%;background-size: 100% 100%;">
                        </h3>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <!-- 公司新闻 -->
        <div class="news_box">
            <div class="wrap">
                <!-- <div class="company_news">
                    <div class="company_title">
                    </div>
                    <div class="company_img" id="company">
                        <img class="jsCompanyDetail hand" src="../assets/images/book.jpg"
                            style="width: 226px; height: 160px;">
                        <span>
                            <h3 class="jsCompanyDetail hand" title="爱的传递|第十九届（春季）全国地方版图书博览会圆满闭幕">爱的传递|第十九届（春季）全国地方...</h3>
                            <p title=""></p>
                        </span>
                    </div>
                    <div class="company_list">
                        <ul id="companyList">
                            <li><em></em><a
                                    href="https://mp.weixin.qq.com/s?__biz=MzA4MTI4NDcwMQ==&amp;mid=2651369833&amp;idx=1&amp;sn=6b7f712b62b741956f05373fdb1e1752&amp;chksm=846b4a5bb31cc34de0bb7f35356a68a4f0b3a7b4fe06e1e06cc058fe72d6ddc81f0c01a37254&amp;token=1878950905&amp;lang=zh_CN#rd"
                                    data-source="https://mp.weixin.qq.com/s?__biz=MzA4MTI4NDcwMQ==&amp;mid=2651369833&amp;idx=1&amp;sn=6b7f712b62b741956f05373fdb1e1752&amp;chksm=846b4a5bb31cc34de0bb7f35356a68a4f0b3a7b4fe06e1e06cc058fe72d6ddc81f0c01a37254&amp;token=1878950905&amp;lang=zh_CN#rd"
                                    data-url="/sxportal/html/newsinfo/newsIndex.html?gid=201802109502400010&amp;newGid=2023040813131900005&amp;totalRecord="
                                    title="雨莺啼破满城春，眼前书香气如兰——第十九届（春季）全国地方版图书博览会启幕"
                                    target="_blank">雨莺啼破满城春，眼前书香气如兰——第十九届（春季）...<img src="../assets/images/new.gif"><img
                                        class="hot" src="../assets/images/hot.gif"></a><i>2023-04-08</i></li>

                            <li><em></em><a
                                    href="https://mp.weixin.qq.com/s?__biz=MzA4MTI4NDcwMQ==&amp;mid=2651369734&amp;idx=2&amp;sn=961698e3cb7d0f7074fe2c8474c04179&amp;chksm=846b4a34b31cc32249016d0e4a1b4ddbb4f2c212f59b0af2f96095a74be64ad4ff6b52c2b11e&amp;token=1878950905&amp;lang=zh_CN#rd"
                                    data-source="https://mp.weixin.qq.com/s?__biz=MzA4MTI4NDcwMQ==&amp;mid=2651369734&amp;idx=2&amp;sn=961698e3cb7d0f7074fe2c8474c04179&amp;chksm=846b4a34b31cc32249016d0e4a1b4ddbb4f2c212f59b0af2f96095a74be64ad4ff6b52c2b11e&amp;token=1878950905&amp;lang=zh_CN#rd"
                                    data-url="/sxportal/html/newsinfo/newsIndex.html?gid=201802109502400010&amp;newGid=2023040813123700004&amp;totalRecord="
                                    title="人民邮电出版社有限公司、浙江大学出版社有限责任公司领导一行莅临三新文化参观指导"
                                    target="_blank">人民邮电出版社有限公司、浙江大学出版社有限责任公司...<img src="../assets/images/new.gif"><img
                                        class="hot" src="../assets/images/hot.gif"></a><i>2023-04-08</i></li>

                            <li><em></em><a
                                    href="https://mp.weixin.qq.com/s?__biz=MzA4MTI4NDcwMQ==&amp;mid=2651369524&amp;idx=1&amp;sn=77a403222bb48627ef825103e0a2ff99&amp;chksm=846b4b06b31cc21059192b2ecc2d2e24ba30ee84501c7b2df81793f6e3b5f0cadb3f63b957e8&amp;token=1878950905&amp;lang=zh_CN#rd"
                                    data-source="https://mp.weixin.qq.com/s?__biz=MzA4MTI4NDcwMQ==&amp;mid=2651369524&amp;idx=1&amp;sn=77a403222bb48627ef825103e0a2ff99&amp;chksm=846b4b06b31cc21059192b2ecc2d2e24ba30ee84501c7b2df81793f6e3b5f0cadb3f63b957e8&amp;token=1878950905&amp;lang=zh_CN#rd"
                                    data-url="/sxportal/html/newsinfo/newsIndex.html?gid=201802109502400010&amp;newGid=2023040813114800003&amp;totalRecord="
                                    title="第19届（春季）全国地方版图书博览会21日开幕，这些文化活动值得期待"
                                    target="_blank">第19届（春季）全国地方版图书博览会21日开幕，这...<img
                                        src="../assets/../assets/images/new.gif"><img class="hot"
                                        src="../assets/images/hot.gif"></a><i>2023-04-08</i></li>

                            <li><em></em><a
                                    href="https://mp.weixin.qq.com/s?__biz=MzA4MTI4NDcwMQ==&amp;mid=2651369523&amp;idx=1&amp;sn=060a42e58d393af6c462615f61c6fbc8&amp;chksm=846b4b01b31cc21775c4f4f119f066dec01d30b39ee7303becb310d7951299c7ddb0fa79f1d6&amp;token=1878950905&amp;lang=zh_CN#rd"
                                    data-source="https://mp.weixin.qq.com/s?__biz=MzA4MTI4NDcwMQ==&amp;mid=2651369523&amp;idx=1&amp;sn=060a42e58d393af6c462615f61c6fbc8&amp;chksm=846b4b01b31cc21775c4f4f119f066dec01d30b39ee7303becb310d7951299c7ddb0fa79f1d6&amp;token=1878950905&amp;lang=zh_CN#rd"
                                    data-url="/sxportal/html/newsinfo/newsIndex.html?gid=201802109502400010&amp;newGid=2023040813105800002&amp;totalRecord="
                                    title="武汉民政职业学院访企拓岗促就业工作座谈会圆满召开" target="_blank">武汉民政职业学院访企拓岗促就业工作座谈会圆满召开<img
                                        src="../assets/images/new.gif"><img class="hot"
                                        src="../assets/images/hot.gif"></a><i>2023-04-08</i>
                            </li>
                        </ul>

                    </div>
                </div> -->
                <div class="industry_news">
                    <div class="booklist_box">
                        <div class="booklist_title">
                            <ul id="bookListTitle">
                                <li class="current san hand" data-booktype="2">景初书目</li>
                            </ul>
                            <a id="bookListMore" href="javascript:;" @click="goDatail">MORE&gt;&gt;</a>
                        </div>
                        <ul class="booklist_nav" id="booklistNav">
                            <li class="hand jsGroupName" :class="indexList == 0?'current':''" @click="changeList('2018020915511601905',0)" title="可供社科">可供社科</li>
                            <li class="hand jsGroupName" :class="indexList == 1?'current':''" @click="changeList('2018021014261407665',1)" title="可供科技">可供科技</li>
                            <li class="hand jsGroupName" :class="indexList == 2?'current':''" @click="changeList('2019022510133116882',2)" title="地方版社科">地方版社...</li>
                            <li class="hand jsGroupName" :class="indexList == 3?'current':''" @click="changeList('2019022510134016883',3)" title="地方版科技">地方版科...</li>
                            <li class="hand jsGroupName" :class="indexList == 4?'current':''" @click="changeList('2018021014262407666',4)" title="可供高职">可供高职</li>
                            <li class="hand jsGroupName" :class="indexList == 5?'current':''" @click="changeList('2018021014263207669',5)" title="可供少儿">可供少儿</li>
                            <div class="clear"></div>
                        </ul>
                        <table class="book_table">
                            <thead>
                                <tr class="table_title">
                                    <th>书目标题</th>
                                    <th>期数</th>
                                    <th>创建时间</th>
                                    <th>操作</th>
                                </tr>
                            </thead>

                            <tbody id="bookTable">
                                <tr class="bookTable" v-for="item in tableData">
                                    <td class="time02" title="三新采访2328期（社科1663条）"><i></i>{{item.listTitle}}</td>
                                    <td class="time01" title="2328"> <em>{{ item.listPeriods }}</em>期</td>
                                    <td class="time01"><b>{{ item.createDate }}</b></td>
                                    <td class="time01"><a href="javascript:;" class="jsDownloadbib" @click="upload(item)">下载</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="partner_box">
            <div class="wrap">
                <img class="title" src="../assets/images/new_he.png">
                <div class="partner_nav">
                    <ul>
                        <li class="current">供应商</li>
                    </ul>
                    <!-- <a >MORE&gt;&gt;</a> -->
                    <div class="clear"></div>
                </div>
                <div class="partner_list">

                    <ul>
                        <li>
                            <i><img src="../assets/images/1.png"></i>
                            <p>清华大学出版社</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/2.png"></i>
                            <p>机械工业出版社</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/3.png"></i>
                            <p>人民邮电出版社</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/4.png"></i>
                            <p>电子工业出版社</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/5.png"></i>
                            <p>化学工业出版社</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/6.png"></i>
                            <p>北京大学出版社</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/7.png"></i>
                            <p>中国人民大学出版</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/8.png"></i>
                            <p>科学出版社</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/9.png"></i>
                            <p>人民卫生出版社</p>
                        </li>
                        <li>
                            <i><img src="../assets/images/10.png"></i>
                            <p>高等教育出版社</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Axios from "@/api/diyaxios";
export default {
    data() {
        return {
            tableData: [],
            pageNum: 1,
            pageSize: 10,
            indexList: 0,
        };
    },
    components: {
        Header,
        Footer
    },
    created() {
        this.changeList('2018020915511601905',0)
        // let a = '三新采访2328期（社科1663条）'
        // const parameter1='三新';
        // const parameter2='景初';
        // const tstring = a.replace(parameter1,parameter2);
        // console.log(tstring);
    },
    methods: {
        changeList(gid,index) {
            let vm = this;
            vm.indexList = index
            Axios.post('/whgs/api/queryhbjingchubycondition', {
                params:{
                    groupid: gid,
                    pageNum: 1,
                    pageSize: 6,
                }
            },{
                headers:{
                    'Content-Type': 'application/json'
                }
            }).then((res) => {
                vm.tableData = res.result.data;
            }).catch((err) => {
                console.log(err);
            });    
        },
        goDatail() {
            this.$router.push({name:'download'})
        },
        upload(item) {
            let vm = this;
            window.open('http://ytzhihui.com' + item.attachUrl)
        },
    }
}
</script>

<style lang="scss" scoped>.banner_box2 {
    height: 700px;
    width: 1200px;
    margin: 0 auto;

    .swiper-wrapper {
        width: 100%;
        height: 700px;
    }
    .red {
        color: red;
    }
}</style>


// WEBPACK FOOTER //
// src/views/Home.vue